<template>
  <div>
    <GoBackView />
    <WebHeaderView />
    <ProductSwipeView :lst="proData.carousel_list" v-if="proData" />
    <ProductInfo :item="proData" />
    <ProductAuctionLst :item="proData" />
    <ShopView
      :shopdata="proData.shop_info"
      v-if="proData && proData.shop_info"
    />
  </div>
</template>

<script>
import WebHeaderView from '@/components/header/index.vue'
import GoBackView from '@/components/goback/index.vue'
import {
  ProductSwipeView,
  ShopView,
  ProductInfo,
  ProductAuctionLst
} from './components/index'
export default {
  name: 'ProductInfoView',
  components: {
    WebHeaderView,
    GoBackView,
    ProductSwipeView,
    ShopView,
    ProductInfo,
    ProductAuctionLst
  },
  data () {
    return {
      proData: null,
      proid: null,
      auction: null,
      timer: null
    }
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
  },
  mounted () {
    this.proid = this.$route.query.id
    if (this.proid) {
      this.getData()
    }
  },
  methods: {
    async getData () {
      await this.$http({
        method: 'post',
        url: 'getProductDetail',
        data: { id: this.proid }
      }).then(res => {
        this.proData = res.data
        if (this.proData.is_auction_end == 0) {
          const that = this
          this.$nextTick(() => {
            that.timer = setInterval(() => {
              that.getDataInter()
            }, 5000)
          })
        }
      })
    },
    async getDataInter(){
      await this.$http({
        method: 'post',
        url: 'getProductDetail',
        data: { id: this.proid }
      }).then(res => {
        this.proData = res.data
      })
    }
  }
}
</script>

<style></style>
